import { Store } from '../../../store/player/types';
import { hasNextRecording } from './hasNextRecording';
import { nextRecording } from './nextRecording';

export const onRecordingDeleted = (
  store: Store,
  data: { recordingDeletedFromThisTab: boolean; recordingId: number },
): void => {
  const { recording, removeRecordingFromList, setNextRecordingCountdown } = store.getState();

  removeRecordingFromList(data.recordingId);

  if (data.recordingDeletedFromThisTab) {
    if (hasNextRecording(store)) {
      setNextRecordingCountdown(+setTimeout(() => nextRecording(store), 2000));
    } else {
      // No other recordings available. Close the window.
      window.close();
    }
  } else {
    if (data.recordingId === recording?.id) {
      // Deleted recording is the same one being viewed. Close the window.
      window.close();
    }
  }
};
